import React, { useState } from 'react';
import Search from '../Search/Search';
import {useDispatch, useSelector} from 'react-redux';
import {setOwnerNav, setRole} from '../../../redux/actions/navigation';
import './Header.1.0.scss';
import { Link } from 'react-router-dom';

const Header = () => {
    const dispatch = useDispatch();
    const {userData, ownerNav} = useSelector(({navigation})=> {
        return {
            userData: navigation.user,
            ownerNav: navigation.ownerNav
        }
    })
    const [openMenu, setOpenMenu] = useState(false)

    const burgerClick = () =>{
        if(!openMenu){
            document.body.style.position = "fixed"
            document.body.style.overflow = 'hidden';
        }
        else{
            document.body.style.position = 'static';
            document.body.style.overflow = 'auto';
        }
        setOpenMenu(!openMenu)
    }
    const cutName = (name) =>{
        if(name !== null && name !== ''){
            let cut = name.split(' ')
            if(cut.length === 3){
                return cut[0] + ' ' + cut[1][0] + '.' + ' ' + cut[2][0] + '.'
            }
            else if(cut.length === 2){
                return cut[0] + ' ' + cut[1][0] + '.'
            }
            else return name
        }
        else return name
    }

 	return (
		<header className="franchises-leaders__header d-flex justify-between">
            {
                (window.innerWidth > 700)?(
                    <div className='franchises-leaders__header-desktop justify-between'>
                        <Search/>
                        <div className="franchises-leaders__buttons d-flex align-center justify-end">
                            {/* <div className={`franchises-leaders__buttons-notifications d-flex justify-center align-center ${(ownerNotification !== 0)? 'active': ''}`}>
                                <img src="/img/notification.svg" alt="" className="franchises-leaders__buttons-notifications-icon"/>
                            </div> */}
                            <div className="franchises-leaders__buttons-user d-flex align-center">
                                <div className="franchises-leaders__buttons-user-photo-container d-flex align-center justify-center">
                                    <img src={userData.src} alt="" className="franchises-leaders__buttons-user-photo"/>
                                </div>
                                <div>
                                    <div className="franchises-leaders__buttons-user-name d-flex align-center">
                                        {cutName(userData.name)}
                                        {/* <img src="/img/arrow-down.svg" alt="" className="franchises-leaders__buttons-user-button"/>  */}
                                    </div>
                                    <div className="franchises-leaders__buttons-user-name-verify d-flex align-center">
                                        <img src="/img/verify.svg" alt="" className="franchises-leaders__buttons-user-name-verify-icon"/>
                                        Руководитель
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                ):(
                    <div className='franchises-leaders__header-mobile-container'>
                        
                        <div className='franchises-leaders__header-mobile justify-between align-center'>
                            <div className={`franchises-leaders__header-burger ${(openMenu)? 'active': ''}`} onClick={burgerClick}>
                                <div className='franchises-leaders__header-burger-item top'></div>
                                <div className='franchises-leaders__header-burger-item center'></div>
                                <div className='franchises-leaders__header-burger-item bottom'></div>
                            </div>
                            <img src="/img/mobile-logo.svg" alt="" className="franchises-leaders__header-mobile-logo"/>                
                        </div>
                                
                        
                        <div className={`franchises-leaders__header-mobile-menu ${(openMenu)? 'active': ''}`}>
                            <Search/>
                            <div className='franchises-leaders__header-mobile-border'></div>
                            <div className='test d-flex flex-wrap justify-between'>
                                <div className="franchises-leaders__nav">
                                    <div className={`franchises-leaders__nav-item-active ${ownerNav}`}>
                                    </div>
                                    <Link to='/'>
                                        <div className="franchises-leaders__nav-item d-flex align-center" onClick={()=>{
                                                dispatch(setOwnerNav("Home"))
                                            }}>
                                            <div className={`franchises-leaders__nav-item-icon home-icon ${(ownerNav === "Home")? "active" : ""}`}></div>
                                            <div className={`franchises-leaders__nav-item-title ${(ownerNav === "Home")? "active" : ""}`} >Точки</div>
                                        </div>
                                    </Link>
                                    <Link to='/staff' >
                                        <div className="franchises-leaders__nav-item d-flex align-center" onClick={()=>{
                                                dispatch(setOwnerNav("Staff"))
                                            }}>
                                            <div className={`franchises-leaders__nav-item-icon staff-icon ${(ownerNav === "Staff")? "active" : ""}`}></div>
                                            <div className={`franchises-leaders__nav-item-title ${(ownerNav === "Staff")? "active" : ""}`}>Сотрудники</div>
                                        </div>
                                    </Link>
                                    <Link to='/warehouse'>
                                        <div className="franchises-leaders__nav-item d-flex align-center" onClick={()=>{
                                                dispatch(setOwnerNav("Warehouse"))
                                            }}>
                                            <div className={`franchises-leaders__nav-item-icon warehouse-icon ${(ownerNav === "Warehouse")? "active" : ""}`}></div>
                                            <div className={`franchises-leaders__nav-item-title ${(ownerNav === "Warehouse")? "active" : ""}`}>Склад</div> 
                                        </div>
                                    </Link>
                                    <Link to='/salaries'>
                                        <div className="franchises-leaders__nav-item d-flex align-center" onClick={()=>{
                                                dispatch(setOwnerNav("Salaries"))
                                            }}>
                                            <div className={`franchises-leaders__nav-item-icon salaries-icon ${(ownerNav === "Salaries")? "active" : ""}`}></div>
                                            <div className={`franchises-leaders__nav-item-title ${(ownerNav === "Salaries")? "active" : ""}`}>Зарплаты</div> 
                                        </div>
                                    </Link>
                                </div>
                                     
                            </div>  
                            <div className="franchises-leaders__sidebar-footer header-footer">
                                <div className="franchises-leaders__buttons-user d-flex align-center mobile">
                                    <div className="franchises-leaders__buttons-user-photo-container d-flex align-center justify-center">
                                        <img src={userData.src} alt="" className="franchises-leaders__buttons-user-photo mobile"/>
                                    </div>
                                    <div>
                                        <div className="franchises-leaders__buttons-user-name d-flex justify-between align-center mobile">
                                            <div>{cutName(userData.name)}</div> 
                                            {/* <img src="/img/arrow-down.svg" alt="" className="franchises-leaders__buttons-user-button"/> */}
                                        </div>
                                        <div className="franchises-leaders__buttons-user-name-verify d-flex align-center mobile">
                                            <img src="/img/verify.svg" alt="" className="franchises-leaders__buttons-user-name-verify-icon mobile"/>
                                            Руководитель
                                        </div>
                                    </div>
                                </div>
                                <button className="owner__logout d-flex align-center" onClick={()=>{
                                    localStorage.setItem('token', '') 
                                    localStorage.setItem('role', '')
                                    sessionStorage.setItem('token', '') 
                                    sessionStorage.setItem('role', '')
                                    dispatch(setRole(''))  
                                }}>
                                    <img src="/img/logout.svg" alt="" className="owner__logout-icon"/>
                                    <div className="owner__logout-title">Выйти из аккаунта</div>                   
                                </button>
                            </div>
                        </div>
                    </div>
                )
            }
        </header>
	)
}
export default Header;